import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {assignedCoursesUrl} from "../../constants/api/soft-user/endpoints";

interface GetCoursesParams {
  hide_completed?: boolean,
  ordering?: string,
  search_term?: string,
  program_ids?: string[],
  current_page?: number,
  portfolio_id?: string
}

export const useQueryAssignedCourses = (params: GetCoursesParams) => {
  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(assignedCoursesUrl, {
      params: params
    })
      .then(response => response?.data?.data ?? response);
  }

  return useQuery({
    queryKey: ['assigned-courses', params],
    queryFn: handleRequest
  })

}
